var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactSheetStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 16.6667,
    fill: "#333333",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5843 16.2359L19.1823 11.0039C19.2579 10.8525 19.3742 10.7252 19.5182 10.6362C19.6622 10.5471 19.8281 10.5 19.9973 10.5C20.1666 10.5 20.3325 10.5471 20.4764 10.6362C20.6204 10.7252 20.7367 10.8525 20.8123 11.0039L23.4103 16.2359L29.2183 17.0799C29.3858 17.1032 29.5435 17.173 29.6732 17.2816C29.8029 17.3901 29.8995 17.5329 29.952 17.6937C30.0044 17.8545 30.0106 18.0268 29.9698 18.1909C29.929 18.355 29.8429 18.5044 29.7213 18.6219L25.5193 22.6919L26.5113 28.4419C26.6383 29.1799 25.8583 29.7419 25.1913 29.3939L19.9973 26.6779L14.8023 29.3939C14.1363 29.7429 13.3563 29.1799 13.4833 28.4409L14.4753 22.6909L10.2733 18.6209C10.1523 18.5033 10.0667 18.3541 10.0263 18.1903C9.98584 18.0264 9.99218 17.8545 10.0446 17.6941C10.097 17.5337 10.1933 17.3912 10.3227 17.2828C10.452 17.1744 10.6092 17.1045 10.7763 17.0809L16.5843 16.2359Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactSheetStar);
export default __webpack_public_path__ + "static/media/FactSheetStar.b35e57f2639bb6f772b1491c1f9392bf.svg";
export { ForwardRef as ReactComponent };